import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  SOCIAL_FETCH,
  SOCIAL_EDIT,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'social' })
export default class Social extends VuexModule {
  sociallList: any = []

  @Mutation
  mutateSocial(social) {
    this.sociallList = social;
  }

  @Action({ commit: 'mutateSocial' })
  FetchSocial(params = {}) {
    return Vue.axios({
      url: BASE_URL + SOCIAL_FETCH,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditSocial(params) {
    return Vue.axios({
      url: BASE_URL + SOCIAL_EDIT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
